import { render } from "./active-orders.vue?vue&type=template&id=abd5df84&scoped=true"
import script from "./active-orders.vue?vue&type=script&lang=js"
export * from "./active-orders.vue?vue&type=script&lang=js"

import "./active-orders.vue?vue&type=style&index=0&id=abd5df84&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abd5df84"]])

export default __exports__